import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import EmailCaptureModal from './EmailCaptureModal';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiClock, FiDollarSign, FiAward, FiHeart, FiUsers, FiMail, FiInstagram, FiCalendar, FiLock, FiUnlock, FiHelpCircle, FiUserPlus } = FiIcons;

const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n || 0);
const fmtN = (n) => new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 }).format(n || 0);

const LiveResultsPanel = ({ calcType, results, inputs }) => {
  const [showModal, setShowModal] = useState(false);
  const accent = calcType === 'website' ? '#3b82f6' : '#a855f7';
  const isAssociation = inputs.organizationType === 'association';

  const websiteBreakdown = [
    ...(isAssociation ? [{ label: 'Member Growth', value: results.membershipValue, icon: FiUserPlus }] : []),
    { label: inputs.organizationType === 'association' ? 'Donation Increase' : 'Increased Donations', value: results.donationIncrease, icon: FiTrendingUp },
    { label: 'Staff Time Savings', value: results.annualTimeSavings, icon: FiClock },
  ];

  const brandingBreakdown = [
    ...(isAssociation ? [{ label: 'Member Growth', value: results.membershipValue, icon: FiUserPlus }] : []),
    { label: isAssociation ? 'Retention Value' : 'Donor Retention', value: results.retentionImprovement, icon: FiHeart },
    { label: isAssociation ? 'New Signups' : 'New Donors', value: results.newDonorValue, icon: FiUsers },
  ];

  const breakdown = calcType === 'website' ? websiteBreakdown : brandingBreakdown;

  return (
    <div className="space-y-4">
      <motion.div className="rounded-2xl text-white p-6 shadow-lg" style={{ background: `linear-gradient(135deg, ${accent} 0%, ${calcType === 'website' ? '#6366f1' : '#7c3aed'} 100%)` }} layout>
        <div className="text-xs font-bold uppercase tracking-widest opacity-70 mb-4">
          {isAssociation ? 'Association' : 'Nonprofit'} {calcType === 'website' ? 'Website' : 'Branding'} ROI
        </div>
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="text-3xl font-bold">{fmtN(results.roi)}%</div>
            <div className="text-xs opacity-70 mt-1">ROI</div>
          </div>
          <div className="border-x border-white/20">
            <div className="text-3xl font-bold">{fmtN(results.paybackMonths)}</div>
            <div className="text-xs opacity-70 mt-1">Mo. Payback</div>
          </div>
          <div>
            <div className="text-2xl font-bold">{fmt(results.threeYearValue)}</div>
            <div className="text-xs opacity-70 mt-1">3-Yr Value</div>
          </div>
        </div>
      </motion.div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
        <h4 className="font-bold text-gray-900 text-sm uppercase tracking-wider mb-4">Annual Benefits</h4>
        <div className="space-y-2">
          {breakdown.filter(item => item.value > 0 || item.label !== 'Donation Increase').map((item) => (
            <div key={item.label} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0">
              <div className="flex items-center gap-2">
                <SafeIcon icon={item.icon} className="text-gray-400 text-sm" />
                <span className="text-sm text-gray-600">{item.label}</span>
              </div>
              <span className="font-bold text-gray-900 text-sm">{fmt(item.value)}</span>
            </div>
          ))}
          <div className="flex items-center justify-between pt-3 mt-1 border-t-2 border-gray-100">
            <span className="font-bold text-gray-900">Total Annual</span>
            <span className="font-bold text-lg" style={{ color: accent }}>{fmt(results.totalAnnualBenefits)}</span>
          </div>
        </div>
      </div>

      <button onClick={() => setShowModal(true)} className="w-full py-4 rounded-2xl text-white font-bold text-sm shadow-lg hover:opacity-90 transition-all flex items-center justify-center gap-2" style={{ background: `linear-gradient(135deg, ${accent}, ${calcType === 'website' ? '#6366f1' : '#7c3aed'})` }}>
        <SafeIcon icon={FiUnlock} /> Unlock Full Report — Free
      </button>
      <EmailCaptureModal isOpen={showModal} onClose={() => setShowModal(false)} onSubmit={() => {}} calculatorType={calcType} previewData={results} />
    </div>
  );
};

export default LiveResultsPanel;